import React from 'react';

const PlayerCardSkeleton = () => {
    return (
        <div className="bg-[#0A0A0A] border-[#1A1A1A] overflow-hidden rounded-[14px] shadow-sm border transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer">
            {/* Player image skeleton - circular */}
            <div className="pt-8 pb-4 flex justify-center">
                <div className="relative">
                    <div className="w-24 h-24 bg-[#111111] rounded-full animate-pulse border-4 border-[#1A1A1A] shadow-lg"></div>
                </div>
            </div>

            {/* Position badge skeleton */}
            <div className="flex justify-center mb-4">
                <div className="bg-[#E8B800] h-6 w-16 rounded-full animate-pulse"></div>
            </div>

            {/* Player info skeleton */}
            <div className="px-6 pb-6 text-center">
                {/* Player name skeleton */}
                <div className="h-7 bg-[#111111] rounded animate-pulse w-32 mx-auto mb-2"></div>

                {/* Height/Weight skeleton */}
                <div className="h-4 bg-[#111111] rounded animate-pulse w-20 mx-auto mb-6"></div>

                {/* Stats skeleton */}
                <div className="flex justify-center space-x-8 mb-6">
                    <div className="text-center">
                        <div className="h-8 bg-[#111111] rounded animate-pulse w-6 mx-auto mb-1"></div>
                        <div className="h-3 bg-[#111111] rounded animate-pulse w-8 mx-auto"></div>
                    </div>
                    <div className="text-center">
                        <div className="h-8 bg-[#111111] rounded animate-pulse w-6 mx-auto mb-1"></div>
                        <div className="h-3 bg-[#111111] rounded animate-pulse w-8 mx-auto"></div>
                    </div>
                    <div className="text-center">
                        <div className="h-8 bg-[#111111] rounded animate-pulse w-6 mx-auto mb-1"></div>
                        <div className="h-3 bg-[#111111] rounded animate-pulse w-8 mx-auto"></div>
                    </div>
                </div>

                {/* Action buttons skeleton */}
                <div className="space-y-2">
                    <div className="w-full h-12 bg-[#E8B800] rounded-xl animate-pulse"></div>
                    <div className="w-full h-12 bg-[#111111] rounded-xl animate-pulse"></div>
                </div>
            </div>
        </div>
    );
};

export default PlayerCardSkeleton
